
export const staffSideMenuItem =
[{
    "userRole":"ecosystm_staff",
    "menuName":"Home",
    "isActive":"true",
    "path":"/ecosystm-staff",
    "imageUrl" : 'assets/images/sidebar-icons/home.svg'
  },
  {
    "userRole":"ecosystm_staff",
    "menuName":"My Bookmarks",
    "isActive":"true",
    "path":"/ecosystm-staff/my-bookmarks",
    "imageUrl" : 'assets/images/sidebar-icons/bookmark.svg'
  },
  {
    "userRole":"ecosystm_staff",
    "menuName":"My Connections",
    "isActive":"true",
    "path":"/ecosystm-staff/my-connections",
    "imageUrl" : 'assets/images/sidebar-icons/connections.svg'
  },
  {
    "userRole":"ecosystm_staff",
    "menuName":"My Social",
    "isActive":"true",
    "path":"/ecosystm-staff/social-feeds",
    "imageUrl" : 'assets/images/sidebar-icons/social.svg'
  },
  {
    "userRole":"ecosystm_staff",
    "menuName":"Messages",
    "isActive":"true",
    "path":"/ecosystm-staff/messages",
    "imageUrl" : 'assets/images/sidebar-icons/message.svg'
  // },
  // {
  //   "userRole":"ecosystm_staff",
  //   "menuName":"Notifications",
  //   "isActive":"true",
  //   "path":"/ecosystm-staff/notifications",
  //   "imageUrl" : 'assets/images/sidebar-icons/notifications.svg'
  },
   {
      "userRole":"ecosystm_staff",
      "menuName":"Manage Subscription",
      "isActive":"true",
      "path":"/ecosystm-staff/manage-subscription",
      "imageUrl" : 'assets/images/sidebar-icons/subscriptions.svg'
    },
    {
       "userRole":"ecosystm_staff",
       "menuName":"Sales Booking",
       "isActive":"true",
       "path":"/ecosystm-staff/sales-booking",
       "imageUrl" : 'assets/images/sidebar-icons/sale.svg'
     }
  ];




// WEBPACK FOOTER //
// ./src/app/shared/constants/ecosystm-staff-menu.ts